/** Shared toast helpers — single look via `ToastContainer.vue`. */

export const TOAST_TYPES = Object.freeze(["success", "error", "warning", "info"]);

const TOAST_ICONS = Object.freeze({
  success: "fa-solid fa-check-circle",
  error: "fa-solid fa-exclamation-circle",
  warning: "fa-solid fa-triangle-exclamation",
  info: "fa-solid fa-info-circle",
});

export const DEFAULT_TOAST_DURATION_MS = 5000;

/**
 * @param {string} type
 * @returns {string}
 */
export function getToastIcon(type) {
  return TOAST_ICONS[type] || TOAST_ICONS.info;
}

/**
 * Supports `(type, title, message)` and `(title, message, type)`.
 * @param {string} a
 * @param {string} [b]
 * @param {string} [c]
 */
export function normalizeToastArgs(a, b, c) {
  if (TOAST_TYPES.includes(a)) {
    return {
      type: a,
      title: b ?? "",
      message: c ?? "",
    };
  }

  const type = TOAST_TYPES.includes(c) ? c : "info";
  return {
    type,
    title: a ?? "",
    message: b ?? "",
  };
}

/**
 * Global toast via App.vue listener.
 * @param {string} a
 * @param {string} [b]
 * @param {string} [c]
 */
export function dispatchAppToast(a, b, c) {
  const { type, title, message } = normalizeToastArgs(a, b, c);
  window.dispatchEvent(
    new CustomEvent("show-toast", {
      detail: { title, message, type },
    }),
  );
}

/**
 * @param {{ type?: string, title?: string, message?: string, id?: number }} payload
 */
export function createToastEntry({ type = "info", title = "", message = "", id } = {}) {
  return {
    id: id ?? Date.now() + Math.random(),
    type,
    title,
    message,
    icon: getToastIcon(type),
    progress: 100,
  };
}

/**
 * @param {{ progress: number }} toast
 * @param {(id: number) => void} removeFn
 * @param {number} [durationMs]
 * @returns {ReturnType<typeof setInterval>}
 */
export function scheduleToastDismiss(toast, removeFn, durationMs = DEFAULT_TOAST_DURATION_MS) {
  const interval = 50;
  const decrement = (interval / durationMs) * 100;

  return setInterval(() => {
    toast.progress -= decrement;
    if (toast.progress <= 0) {
      removeFn(toast.id);
    }
  }, interval);
}
